import {TASK_ACTIONS, KEYS, DIRECT_TASK_ACTIONS} from './constants';
import * as _ from "lodash";
import {approveMultipleShortcutKey} from "../components/mytasks/myTasks.action";
import store from 'components/store/Store.component';

const TEXT_AREA = "textarea";
const TEXT = "text";
const EMAIL_INPUT = "email";

/**
 * convert utc to localized string
 * @param event
 * @param taskAction
 * @param selectedKeys
 * @param activeActions
 * @param navigate
 */
export function keyPressHandler(event, taskAction, selectedKeys, activeActions, navigate = () => {
}) {
    if (!canDo(event)) return;

    if (event.shiftKey && event.key === "A") {
        event.preventDefault();
        if (activeActions.isEnabled(TASK_ACTIONS.APPROVE)) {
            doActionFromList(activeActions, DIRECT_TASK_ACTIONS.APPROVE_IMMEDIATELY, taskAction, selectedKeys, navigate);
        }
        return
    }

    switch (event.keyCode) {
        //pressed 'a' -> open approve dialog
        case KEYS.A_KEY:
            event.preventDefault();
            let shouldEnforceDialog = selectedKeys.length > 0;
            store.dispatch(approveMultipleShortcutKey(shouldEnforceDialog));
            doActionFromList(activeActions, TASK_ACTIONS.APPROVE, taskAction, selectedKeys, navigate);
            break;
        //pressed 'e' -> open email dialog
        case KEYS.E_KEY:
        case KEYS.M_KEY:
            event.preventDefault();
            doActionFromList(activeActions, TASK_ACTIONS.EMAIL, taskAction, selectedKeys, navigate);
            break;
        //pressed 'f' -> open forward dialog
        case KEYS.F_KEY:
            event.preventDefault();
            doActionFromList(activeActions, TASK_ACTIONS.FORWARD, taskAction, selectedKeys, navigate);
            break;
        //pressed 'r' -> open reject dialog
        case KEYS.R_KEY:
            event.preventDefault();
            doActionFromList(activeActions, TASK_ACTIONS.REJECT, taskAction, selectedKeys, navigate);
            break;
        //pressed 'v' -> open review dialog
        case KEYS.V_KEY:
            event.preventDefault();
            doActionFromList(activeActions, TASK_ACTIONS.SEND_FOR_REVIEW, taskAction, selectedKeys, navigate);
            break;
        default:
        // nothing
    }

}

export function canDo(e) {
    if (e.target?.id === "chat-component")
        return false;
    if (e.target instanceof Element && e.target.classList.contains("ga-input__field")) {
        return false;
    }
    //do not navigate when user in in a text area or if the popup is visible
    let notPopUpVisible = document.getElementsByClassName("pop-up").length === 0;
    let isNotTextArea = e.target?.type !== TEXT_AREA && e.target?.type !== TEXT && e.target?.type !== EMAIL_INPUT;
    let isNotComboKeyPress = !e.ctrlKey && !e.metaKey && !e.altKey;

    return (isNotTextArea && notPopUpVisible && isNotComboKeyPress);
}

export function handleNPKeyNavigation(event, taskId, callbackToExecute) {
    //do not navigate when user in a text area or if the popup is visible
    let notPopUpVisible = document.getElementsByClassName("pop-up").length === 0;
    let isNotTextArea = event.target.type !== TEXT_AREA && event.target.type !== TEXT && event.target?.type !== EMAIL_INPUT;
    if (isNotTextArea && notPopUpVisible) {
        const isNextKey = ["N", "n", "X", "x"].includes(event.key);
        const isPrevKey = ["P", "p", "Z", "z"].includes(event.key);


        const debouncedCallback = _.debounce(callbackToExecute, 500);
        if (isNextKey) {
            debouncedCallback(taskId, true);
        } else if (isPrevKey) {
            debouncedCallback(taskId, false);
        }
    }
}


export function doActionFromList(activeActions, action, taskAction, selectedKeys, navigate) {
    if (action === DIRECT_TASK_ACTIONS.APPROVE_IMMEDIATELY || activeActions.isEnabled(action)) {
        taskAction(action, selectedKeys, navigate ? {navigate} : {});
    }
}
